import { createAction, createSlice } from '@reduxjs/toolkit';
import { FilterModel } from '@tassat/common-definitions';
import { UserRole } from '@tassat/fred-definitions';

import Worker from 'Lib/worker/PrimusWorker';

export interface TableFilter {
    [key: string]: FilterModel;
}
export interface UiState {
    inactive: boolean;
    disconnected: boolean;
    connected: boolean;
    themeRefreshed: boolean;
    userEventTriggered: boolean;
    userRoles: UserRole[];
    fetchedUserRoles: boolean;
    currentPage: string;
    currentRole: UserRole;
    selectedAccountId: string;
    selectedFilter: TableFilter;
    isLiquidityFacilityAvailable: boolean;
}

const initialState: UiState = {
    inactive: false,
    disconnected: false,
    connected: false,
    themeRefreshed: false,
    userEventTriggered: false,
    userRoles: [],
    fetchedUserRoles: false,
    currentPage: '',
    currentRole: {} as UserRole,
    selectedAccountId: '',
    selectedFilter: {},
    isLiquidityFacilityAvailable: false
};

const liquidityFacilityClientStatus = createAction<{ LiquidityFacility: boolean }>('LiquidityFacilityClientStatus');
const themeRefreshed = createAction('ThemeRefreshed');
const customerInactivity = createAction('CustomerInactivity');
const connectedToCore = createAction('ConnectedToCore');
const disconnectedFromCore = createAction('DisconnectedFromCore');
const mockCurrentRole = createAction<{ currentRole: UserRole }>('MockCurrentRole');

const uiStateSlice = createSlice({
    name: 'ui-state',
    initialState,
    reducers: {
        setUserRoles (state, action) {
            state.userRoles = action.payload;
            state.fetchedUserRoles = true;
        },
        setUserRole (state, action) {
            state.currentRole = action.payload;
        },
        continueUserSession (state) {
            state.inactive = false;
        },
        setUserEventTriggered(state) {
            state.userEventTriggered = true;
        },
        uiInactivity(state) {
            state.inactive = true;
        },
        setSelectedAccount (state, action) {
            state.selectedAccountId = action.payload;
        },
        MockCurrentRole (state, action) {
            if (import.meta.env.NPM_CONFIG_MOCK){
                state.currentRole = action.payload.currentRole;
            }
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(connectedToCore, (state) => {
                state.connected = true;
                state.disconnected = false;

                return state;
            })
            .addCase(disconnectedFromCore, (state) => {
                state.disconnected = true;

                return state;
            })
            .addCase(themeRefreshed, (state) => {
                state.themeRefreshed = true;

                return state;
            })
            .addCase(customerInactivity, (state) => {
                if (state.userEventTriggered) {
                    Worker.getInstance()
                        .extendSession();
                    state.userEventTriggered = false;
                } else {
                    state.inactive = true;
                }

                return state;
            })
            .addCase(liquidityFacilityClientStatus, (state, action) => {
                state.isLiquidityFacilityAvailable = action.payload.LiquidityFacility;

                return state;
            })
            .addCase(mockCurrentRole, (state, action) => {
                if (process.env.NPM_CONFIG_MOCK){
                    state.currentRole = action.payload.currentRole;
                }

                return state;
            });
    }
});

export const {
    continueUserSession,
    setSelectedAccount,
    setUserEventTriggered,
    setUserRole,
    setUserRoles,
    uiInactivity
} = uiStateSlice.actions;
export default uiStateSlice.reducer;